import React from "react";
import { WSButton, WSMarginProps } from "@wingspanhq/fe-component-library";

type GoogleSignInProps = WSMarginProps & {
  title?: string;
};

export const GoogleSignIn: React.FC<GoogleSignInProps> = ({
  title = "Sign up with Google",
  ...otherProps
}) => (
  <WSButton.Tertiary fullWidth type="button" size="M" disabled {...otherProps}>
    {title}
  </WSButton.Tertiary>
);
